// Primary project discipline tags + scope completeness (Discipline Tagging feature).
export const DISCIPLINES = [
  { key: "civil", label: "Civil / Sitework" },
  { key: "mechanical", label: "Structural / Mechanical" },
  { key: "electrical_dc", label: "Electrical — DC" },
  { key: "electrical_ac", label: "Electrical — AC / MV" },
  { key: "substation", label: "Substation" },
  { key: "commissioning", label: "Testing & Commissioning" },
  { key: "full_epc", label: "Full EPC" },
  { key: "other", label: "Other" },
];

export const DISCIPLINE_LABELS = Object.fromEntries(DISCIPLINES.map((d) => [d.key, d.label]));
export const disciplineLabel = (k) => DISCIPLINE_LABELS[k] || (k || "—");

export const SCOPE_COMPLETENESS = [
  { key: "full", label: "Full scope" },
  { key: "partial", label: "Partial scope" },
];

// Material responsibility per scope line.
export const MATERIAL_BY = [
  { key: "us", label: "We furnish" },
  { key: "client", label: "Client furnishes" },
  { key: "split", label: "Split" },
];

export const MATERIAL_BAND_LABELS = {
  labor_only: "Labor only", partial_material: "Partial material",
  full_material: "Full material", unspecified: "Unspecified",
};

// A fresh scope line with sensible defaults.
export const newScope = (discipline, lead = false) => ({
  discipline, lead, completeness: "full", completeness_note: "",
  work_pct: 100, material_by: "us", material_pct: 100,
});

// Coarse discipline_scope bucket (legacy bid field) → representative discipline keys.
export const SCOPE_TO_DISCIPLINES = {
  civil: ["civil"],
  mechanical: ["mechanical"],
  electrical: ["electrical_dc"],
  both: ["electrical_dc", "mechanical"],
};

// Scope lines for a bid/lead — the stored list, else synthesized from legacy discipline fields.
export const scopesFromDoc = (doc = {}) => {
  if (Array.isArray(doc.scopes) && doc.scopes.length) return doc.scopes;
  let list = [doc.discipline, ...(doc.additional_disciplines || [])].filter(Boolean);
  if (!list.length && doc.discipline_scope) {
    list = SCOPE_TO_DISCIPLINES[doc.discipline_scope] || [doc.discipline_scope];
  }
  return list.map((d, i) => ({
    discipline: d, lead: i === 0, completeness: doc.scope_completeness || "full",
    completeness_note: doc.scope_completeness_note || "", work_pct: 100,
    material_by: "us", material_pct: 100,
  }));
};
